var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.8625V6.6375C16.5 8.325 15.825 9 14.1375 9H12.1125C10.425 9 9.75 8.325 9.75 6.6375V3.8625C9.75 2.175 10.425 1.5 12.1125 1.5H14.1375C15.825 1.5 16.5 2.175 16.5 3.8625Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.3625V14.1375C8.25 15.825 7.575 16.5 5.8875 16.5H3.8625C2.175 16.5 1.5 15.825 1.5 14.1375V11.3625C1.5 9.675 2.175 9 3.8625 9H5.8875C7.575 9 8.25 9.675 8.25 11.3625Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25C16.5 14.1525 14.1525 16.5 11.25 16.5L12.0375 15.1875",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75C1.5 3.8475 3.8475 1.5 6.75 1.5L5.9625 2.8125",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeTable);
export default __webpack_public_path__ + "static/media/changeTable.060f1b24979853a0aa3b1df1004bdc1a.svg";
export { ForwardRef as ReactComponent };